import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "description", "action", "checklist", "divider", "videoContainer"]
  static values = { 
    initialTask: String,
    completedTasks: Array
  }

  connect() {
    this.initializeChecklist()
  }

  initializeChecklist() {
    // Hide all descriptions and actions initially
    this.itemTargets.forEach(item => {
      const description = item.querySelector('.task-description')
      const action = item.querySelector('.task-action')
      const title = item.querySelector('p.text-gray-900')
      if (description) {
        description.style.display = 'none'
      }
      if (action) {
        action.style.display = 'none'
      }
      if (title) {
        title.classList.remove('font-semibold')
      }
      // Remove any existing highlight classes
      item.classList.remove('bg-gray-50', 'p-4', '-mx-4', '!rounded-2xl')
    })

    // Set initial selected task (only the first incomplete task)
    const incompleteTasks = this.itemTargets.filter(item => {
      const checkbox = item.querySelector('.w-8.h-8.rounded-full')
      const isCompleted = checkbox && checkbox.classList.contains('bg-black')
      return !isCompleted
    })

    if (incompleteTasks.length > 0) {
      // Select the first incomplete task
      const selectedTask = incompleteTasks[0]
      this.selectTask(selectedTask)
    }
  }

  selectTask(taskElement) {
    // Remove highlight from all items
    this.itemTargets.forEach(item => {
      item.classList.remove('bg-gray-50', 'p-4', '-mx-4', '!rounded-2xl')
      const description = item.querySelector('.task-description')
      const action = item.querySelector('.task-action')
      const title = item.querySelector('p.text-gray-900')
      if (description) description.style.display = 'none'
      if (action) action.style.display = 'none'
      if (title) title.classList.remove('font-semibold')
    })

    // Add highlight to selected item
    taskElement.classList.add('bg-gray-50', 'p-4', '-mx-4', '!rounded-2xl')
    
    const description = taskElement.querySelector('.task-description')
    const action = taskElement.querySelector('.task-action')
    const title = taskElement.querySelector('p.text-gray-900')
    if (description) {
      description.style.display = 'block'
    }
    if (action) {
      action.style.display = 'block'
    }
    if (title) {
      title.classList.add('font-semibold')
    }
  }

  itemClick(event) {
    // Don't trigger if clicking on a link or button
    if (event.target.closest('a') || event.target.closest('button')) {
      return
    }

    const clickedTask = event.currentTarget
    const isCurrentlySelected = clickedTask.classList.contains('bg-gray-50')

    if (isCurrentlySelected) {
      // If already selected, deselect it
      this.deselectTask(clickedTask)
    } else {
      // If not selected, select it
      this.selectTask(clickedTask)
    }
  }

  deselectTask(taskElement) {
    // Remove highlight from the task
    taskElement.classList.remove('bg-gray-50', 'p-4', '-mx-4', '!rounded-2xl')
    
    // Hide description and action
    const description = taskElement.querySelector('.task-description')
    const action = taskElement.querySelector('.task-action')
    const title = taskElement.querySelector('p.text-gray-900')
    if (description) description.style.display = 'none'
    if (action) action.style.display = 'none'
    if (title) title.classList.remove('font-semibold')
  }

  toggleContainer() {
    // Toggle visibility of checklist and divider
    if (this.hasChecklistTarget) {
      const currentDisplay = this.checklistTarget.style.display
      this.checklistTarget.style.display = currentDisplay === 'none' ? 'flex' : 'none'
    }
    if (this.hasDividerTarget) {
      const currentDisplay = this.dividerTarget.style.display
      this.dividerTarget.style.display = currentDisplay === 'none' ? 'block' : 'none'
    }
    // Toggle visibility of video container
    if (this.hasVideoContainerTarget) {
      const currentDisplay = this.videoContainerTarget.style.display
      this.videoContainerTarget.style.display = currentDisplay === 'none' ? 'block' : 'none'
    }
  }
}
